module.exports = __webpack_public_path__ + "img/added-services.87808722.svg";